import { withAuthenticationRequired } from "@auth0/auth0-react";
import React, { ComponentType, useMemo } from "react";
import { PageLoader } from "./page-loader";

interface AuthenticationGuardProps {
  component: ComponentType;
}

export const AuthenticationGuard: React.FC<AuthenticationGuardProps> = ({
  component,
}) => {
  // withAuthenticationRequired mints a brand-new component type on every call,
  // so it must not be called bare during render: a changed type makes React
  // unmount and remount the guarded page, silently wiping its state. This
  // guard re-renders whenever the Auth0 context changes — which any page that
  // refreshes the session mid-flow (a forced getAccessTokenSilently) causes —
  // so the wrapped component must keep a stable identity across renders.
  const Component = useMemo(
    () =>
      withAuthenticationRequired(component, {
        onRedirecting: () => (
          <div className="page-layout">
            <PageLoader />
          </div>
        ),
      }),
    [component]
  );

  return <Component />;
};
